var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 259,
    viewBox: "0 0 259 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129.5,
    cy: 129.5,
    r: 129.5,
    fill: "url(#paint0_linear_1524_44)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 188.5V174C69 170 100.5 169 140.5 137C145.819 132.745 179 99 189.5 77L176.5 70.5L210.5 47L214 87.5L202.5 81.5C202.5 81.5 187.415 103.432 176.5 116.5C165.519 129.647 159.783 137.684 146.5 148.5C129.014 162.739 117.089 168.515 96 176.5C76.865 183.745 45 188.5 45 188.5Z",
    fill: "#278569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 213H44V198C48.5 197.5 58 196.5 63.5 195.5C79 192.682 80.6667 191.167 86 189V213Z",
    fill: "#278569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 174C118.831 178.26 106.5 184.167 100.5 185.5V213H142V163.5C140.5 165 135 169.278 126.5 174Z",
    fill: "#278569"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 131.5C172 142 163.333 147.667 157 152.5V213H199V106C194.833 111.833 189 121 180.5 131.5Z",
    fill: "#278569"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1524_44",
    x1: 269,
    y1: 130,
    x2: -9,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A27A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526167,
    stopColor: "#F6EDA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A27A49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinsight);
export default __webpack_public_path__ + "static/media/winsight.987b6d59c69a57ad08caf991162969e2.svg";
export { ForwardRef as ReactComponent };